import { GetServerSideProps } from "next";
import QueryString from "qs";

const apiBaseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;
let sitemapBaseUrl: any = process.env.NEXT_PUBLIC_SITEMAP_BASE_URL;

// Ensure the base URL has a trailing slash
if (!sitemapBaseUrl.endsWith("/")) {
  sitemapBaseUrl += "/";
}

// Function to generate the Case Study sitemap XML
const generateCaseStudySiteMap = (caseStudyUrls: string[]) => {
  return `<?xml version="1.0" encoding="UTF-8"?>
    <?xml-stylesheet type="text/xsl" href="${sitemapBaseUrl}main-sitemap.xsl"?>
    <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
        ${caseStudyUrls
          .map(
            (url: string) => `
                <url>
                    <loc>${url}</loc>
                    <changefreq>weekly</changefreq>
                    <priority>0.8</priority>
                </url>
                `
          )
          .join("")}
    </urlset>`;
};

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  try {
    const caseStudyUrls: string[] = [];
    let totalPages = 1;
    const pageSize = 100;

    for (let i = 1; i <= totalPages; i++) {
      const query = QueryString.stringify(
        {
          fields: ["slug"],
          filters: { slug: { $ne: "case-studies" } },
          pagination: { page: i, pageSize },
        },
        { encodeValuesOnly: true }
      );

      const response = await fetch(`${apiBaseUrl}case-studies-v2?${query}`);
      const json = await response.json();
      const items = json?.data || [];

      if (i === 1) {
        totalPages = json?.meta?.pagination?.pageCount || 1;
      }

      items.forEach((item: any) => {
        const slug = item?.attributes?.slug;
        if (slug) {
          caseStudyUrls.push(`${sitemapBaseUrl}case-studies/${slug}`);
        }
      });
    }

    const sitemap = generateCaseStudySiteMap(Array.from(new Set(caseStudyUrls)));

    res.setHeader("Content-Type", "text/xml");
    res.write(sitemap);
    res.end();
  } catch (error) {
    console.error("Error generating Case Study sitemap:", error);
    res.statusCode = 500;
    res.end();
  }

  return { props: {} };
};

export default function CaseStudySiteMap() {}
